import {Component, Input, OnInit} from '@angular/core';
import {TipoPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';

@Component({
  selector: 'app-documento-aditivo',
  templateUrl: './documento-aditivo.component.html',
  styleUrls: ['./documento-aditivo.component.scss'],
})
export class DocumentoAditivoComponent implements OnInit {
  @Input() codigoProposta: any;
  @Input() nomeTitular: any;
  @Input() entidadeProposta: any;
  @Input() tipoProposta!: TipoPropostaEnum;
  @Input() nomeEntidade!: string;
  @Input() razaoSocialEntidade!: string;
  @Input() dadosOperadoraDM!: any;
  @Input() vigenciaProposta!: any;
  @Input() operadoraVM!: any;
  @Input() dadosOperadoraCabecalho!: any;

  tipoPropostaPortabilidade: boolean = false;
  tipoPropostaSumula: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (this.tipoProposta == TipoPropostaEnum.PORTABILIDADE) {
      this.tipoPropostaPortabilidade = true;
      this.tipoPropostaSumula = false;
    } else if (this.tipoProposta == TipoPropostaEnum.SUMULA) {
      this.tipoPropostaSumula = true;
      this.tipoPropostaPortabilidade = false;
    } else {
      this.tipoPropostaSumula = false;
      this.tipoPropostaPortabilidade = false;
    }
  }
}
